module.exports = new __parcel__URL__("shop_legendary_resource_box_image.0410bcdf.png").toString();